import { Component, Inject, Input } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EventsService, RedirectionLinkType } from 'simpo-component-library';
import { WebisiteService } from 'src/app/master-config-components/micro-apps/website/webisite.service';
import { EventEmmiterService } from 'src/app/services/event-emmiter.service';
import { ImageUploadService } from 'src/app/services/ImageUploadService/image-upload.service';
import { TemplateService } from 'src/app/services/template.service';
import { WebsiteGenerationService } from 'src/app/website-generation/website-generation.service';

@Component({
  selector: 'app-list-item-component',
  templateUrl: './list-item-component.component.html',
  styleUrls: ['./list-item-component.component.scss']
})
export class ListItemComponentComponent {
  constructor(
    private eventEmitterService: EventEmmiterService,
    private websiteGenerationService: WebsiteGenerationService,
    public websiteService: WebisiteService,
    private dialogSercvice: TemplateService,
    private snackBar: MatSnackBar,
    private imageUploadService: ImageUploadService,
    private eventsService: EventsService
  ) { }

  @Input() data: any;
  @Input() sectionId: string = ''
  @Input() templatePage: any[] = [];
  @Input() currentPageIndex: number = 0;
  @Input() newItem: boolean = false;
  @Input() buttonData?: boolean;
  @Input() content: any;
  public loading: string | null = null;
  public regerateLoading: boolean = false;

  addingAdditionalData: boolean = false;
  additionalContent: string = ''
  backgroundType: string[] = ['Solid', 'Gradient']

  tabs = [
    { name: 'CONTENT', label: 'Content', status: true },
    { name: 'STYLES', label: 'Styles', status: false }
  ];
  selectedTab: string = 'CONTENT';

  tabShift(name: string): void {
    this.tabs.forEach(t => t.status = t.name === name);
    this.selectedTab = name;
  }

  get hasContentTab(): boolean {
    if (!this.data) return false;
    return this.data.hasOwnProperty('image') ||
      this.data.hasOwnProperty('inputText') ||
      this.data.hasOwnProperty('button') ||
      this.data.hasOwnProperty('highlight') ||
      this.data.hasOwnProperty('additionalData') ||
      this.data.hasOwnProperty('content') ||
      !!this.data.hotspots;
  }

  get hasStylesTab(): boolean {
    if (!this.data) return false;
    return this.data.hasOwnProperty('background');
  }

  get showTabs(): boolean {
    return this.hasContentTab && this.hasStylesTab;
  }

  ngOnInit() {
    if (this.newItem) {
      this.ClearingAllData()
    }
    if (this.data?.additionalData?.length > 0) {
      for (let addition of this.data?.additionalData) {
        addition['edit'] = false;
      }
    }
    if (!this.hasContentTab && this.hasStylesTab) {
      this.tabShift('STYLES');
    }
    // if (this.listItemdata) {
    //   this.data = this.listItemdata.data;
    //   this.sectionId = this.listItemdata.sectionId
    //   if (this.listItemdata.newItem) {
    //     this.ClearingAllData()
    //   }
    //   this.templatePage = this.listItemdata.templatePage
    //   this.currentPageIndex = this.listItemdata.currentPageIndex
    // }
  }

  // showImageEditor() {
  //   if (this.content?.display?.hasOwnProperty('showImage') && this.content?.display?.showImage)
  //     return true;
  //   if (this.data?.hasOwnProperty('image'))
  //     return true;
  //   return false;
  // }

  getUnsplaceImage() {
    this.regerateLoading = true;
    this.dialogSercvice.searchPhotosInUnsplash(JSON.parse(String(localStorage.getItem('bDetails')))?.subIndustryName ?? '', 0, 100).subscribe((response: any) => {
      this.regerateLoading = false;
      const index: number = Math.floor(Math.random() * (response.results.length));
      this.data.image.url = response.results[index].urls.full;
    }, (error) => {
      this.regerateLoading = false;
    })
  }


  // closeDialog() {
  //   this.dialogRef.close()
  // }

  ClearingAllData() {
    if (this.data?.hasOwnProperty('image')) {
      this.data.image.url = ''
      if (this.data?.image?.altText) {
        this.data.image.altText = ''
      }
      if (this.data?.image?.position) {
        this.data.image.position.x = 0;
        this.data.image.position.y = 0;
      }

    }
    if (this.data?.inputText) {
      for (let input of this.data.inputText) {
        input.value = ''
      }
    }
    if (this.data?.hotspots) {
      this.data.hotspots = [
        {
          id: crypto.randomUUID(),
          title: '',
          img: "",
          x: 50,
          y: 50,
          linkText: '',
          link: ''
        },
      ]
    }
    if (this.data?.hasOwnProperty('button')) {
      this.data.button = {
        linkType: RedirectionLinkType.External,
        label: '',
        redirectionUrl: '',
        newTab: false,
        icon: {
          id: `${this.content?.listItem?.data?.length + 'btnIcon' + 1}`,
          url: '',
          iconPosition: 'left',
          altText: 'Icon'
        }
      }
    }
    if (!this.buttonData && this.data?.hasOwnProperty('content')) {
      this.data.content = null;
    }
  }

  addNewItem() {
    // this.dialogRef.close({ data: this.data })
    // if (this.data?.hasOwnProperty('image')) {
    //   if (!this.data?.image?.url) {
    //     this.snackBar.open('Please add image in image field', 'ok', { duration: 3000 });
    //     return;
    //   }
    //   this.data.image.id = this.content?.listItem?.data?.length + 1;
    // }
    if (this.data?.hasOwnProperty('image')) {
      this.data.image.id = this.content?.listItem?.data?.length + 1;
    }
    if (this.data?.hasOwnProperty('icon')) {
      let id = this.content?.listItem?.data?.length + 1;
      this.data.icon.id = `icon${id}`;
    }
    this.content.listItem.data.push(this.data);
    this.dialogSercvice.secondaryEditor.emit({ data: { tab: 'STYLES' } });
    this.dialogSercvice.goBack.emit({ back: true });
  }

  onTextValueChange() {
    this.websiteGenerationService.markSectionForCheck(this.sectionId);
  }

  emitIconChange() {
    this.eventsService.iconChanged.emit({ id: this.sectionId + this.data.icon?.id, icon: this.data.icon });
    this.onTextValueChange();
  }

  async uploadIcon(event: any) {
    const file = event.target.files[0];
    if (!file) return;
    const response: any = await this.imageUploadService.uploadPageScreenShots(file, 'library-media');
    if (!this.data.icon) this.data.icon = {};
    this.data.icon.url = response.Location;
    this.emitIconChange();
  }

  deleteIcon() {
    if (this.data.icon) this.data.icon.url = '';
    this.emitIconChange();
  }

  removeHtml(value: string): string {
    if (!value) return '';

    const div = document.createElement('div');
    div.innerHTML = value;

    // textContent automatically removes tags AND decodes entities
    let text = div.textContent || div.innerText || '';

    // replace non-breaking space with normal space
    return text.replace(/\u00A0/g, ' ').trim();
  }
  regerateContent(inputText) {
    if (this.loading == inputText.label)
      return;
    this.loading = inputText.label;
    const bDetails = JSON.parse(localStorage.getItem("bDetails") ?? "");
    if (!bDetails)
      return;
    const payload = {
      "dataId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      "subIndustryId": bDetails.subIndustryId,
      "businessId": bDetails.id,
      // "businessName": "string", industryId
      "customPrompt": "",
      "label": inputText.label,
      "value": inputText.value,
      "suggestedDataType": "COMPONENT",
      "tone": "PROFESSIONAL",
      // "wordLimit": 0
    }
    this.websiteService.regenerateIndividualV2(payload).subscribe((response: any) => {
      inputText.value = response.data;
    }, (error) => {

    })
  }

  editAdditionalData(details: any) {
    let dialog = this.dialogSercvice.openDialog(ListItemComponentComponent, 'auto',
      '460px', { data: details, newItem: false, buttonData: false });
  }

  deleteAdditionalCharge(index: number) {
    this.data?.additionalData.splice(index, 1);
  }

  addAdditionalData() {
    // let dialog = this.dialogSercvice.openDialog(ListItemComponentComponent, 'auto',
    // '460px', { data: JSON.parse(JSON.stringify(this.data?.additionalData[0])), newItem: true, buttonData: false });

    // dialog.afterClosed().subscribe((res: any) => {
    //   if(res.data) {
    //     this.data.additionalData.push(res.data)
    //   }
    // })
    this.data.additionalData.push({ content: this.additionalContent });
    this.addingAdditionalData = false
  }

  removeHotspot(index: number) {
    this.data.hotspots.splice(index, 1);
  }



  addHotspot() {
    this.data.hotspots.push({
      id: crypto.randomUUID(),
      title: '',
      img: '',
      x: 50,
      y: 50,
      linkText: '',
      link: ''
    });
  }

}
